import React from 'react'
import InfoSection from 'components/InfoSection'
import HelpIcon from 'components/icons/HelpIcon'

export default function SideInfoHelp() {
  return (
    <InfoSection
      icon={<HelpIcon />}
      title={
        <a
          href="https://help.rambler.ru/id/"
          target="_blank"
          rel="noopener noreferrer">
          Помощь по работе с Профилем
        </a>
      }>
      Чтобы узнать обо всех возможностях Единого профиля, загляните в раздел
      Помощи
    </InfoSection>
  )
}
